import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import UIAssetKeys from '../UIAssetKeys';

export default class PicnicBasket extends Phaser.GameObjects.Image
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {number} x 
     * @param {number} y 
     */
    constructor(scene, x, y)
    {
        super(scene, x, y, ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._animations_basket_open_0);

        this.scene.add.existing(this);

        this.setOrigin(0);
    }
}